/*
  Address types
  1 Distribution Center
  2 Shipping
  3 Billing
  4 Receiving
  5 Mailing
  6 Remit to
  7 Yard
  8 Physical
*/

export interface AddressType {
  AddressId: number;
  AddressTypeId: number;
  Address1: string;
  Address2?: string;
  City: string;
  Country: string;
  State: string;
  Zip: string;
  Zone: string;
}

export interface CarrierType {
  CarrierCode: string;
  CarrierId: number;
  CarrierName: string;
  DOTNumber: number;
  Addresses: [AddressType];
  PayToAddress: AddressType;
  CarrierEquipments: [CarrierEquipmentType];
  CarrierEquipment: string;
  ComplianceStatus: string;
  IsCompliant: boolean; // ComplianceStatus === 'Approved'
  IsHazmatCertified: boolean;
  UseMP: boolean;
  HasAutoTracking: boolean;
  LoadTrackingVendorId: number;
  CarrierRepId: number;
  CargoInsExpirationDate: string;
  LiabilityInsExpirationDate: string;
  CargoInsRenewalEffectiveDate: string | null;
  LiabilityInsRenewalEffectiveDate: string | null;
  ConnectionMethodTypeId: number;
  HasReeferIns: boolean;
  UnitCount: number;
  IsHighRiskCertified: boolean;
}

export interface CarrierEquipmentType {
  CarrierId: number;
  CarrierTruckEquipmentType: number;
  Units?: number;
  Description: string;
}

export enum ConnectionMethodType {
  STANDARD = 1,
  EDI = 2
}